import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/lib/v2/components';
import { Divide, Flex } from '@/lib/v2/components/Layout/Stack';
import { Text } from '@/lib/v2/components/Text';

type MappedFieldProps = {
  listMappedField: Array<string>;
  isOpenModalMappedFields: boolean;
  setIsOpenModalMappedFields: Dispatch<SetStateAction<boolean>>;
};

export const MappedFieldModal = ({
  listMappedField,
  isOpenModalMappedFields,
  setIsOpenModalMappedFields,
}: MappedFieldProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpenModalMappedFields} onClose={() => setIsOpenModalMappedFields(false)}>
      <div className="visible-scrollbar my-1.5 h-fit max-h-96 overflow-auto rounded-md">
        <Divide>
          <Flex column withGap gapSize="small" itemAlignment="stretch">
            <Text variant="headline">{t('IMPORT_MAIN.mappedField')}</Text>
            <Divide>
              <Flex column withGap gapSize="small" itemAlignment="stretch">
                {listMappedField.map((fieldElement) => {
                  return (
                    <div key={fieldElement} className="py-4 capitalize">
                      <Text>{fieldElement}</Text>
                    </div>
                  );
                })}
              </Flex>
            </Divide>
          </Flex>
        </Divide>
      </div>
    </Modal>
  );
};
